import * as React from "react";

import { Badge, IconButton, Tooltip } from "@material-ui/core";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";

import { IButtonProps } from "./IButtonProps";
import { SettingsDialog } from "./SettingsDialog";
import { QuiltParamsHelper } from "Utility/QuiltParamsHelper";


export function SettingsButton(props: IButtonProps): React.ReactElement {
    const [show, setShow] = React.useState(false);
    const disabled = props.quiltRenderData === null || props.disabled;

    const invisible = !QuiltParamsHelper.hasChanges(props.params);

    const tooltip = "Quilt settings" + (invisible ? "" : " (changed)");

    return (
        <>
           <Tooltip title={tooltip}>
               <span>
                    <Badge color="secondary" variant="dot" invisible={invisible}>
                        <IconButton size="small" color="primary" onClick={() => setShow(true)} disabled={disabled}>
                            <SettingsOutlinedIcon/>
                        </IconButton>
                    </Badge>
               </span>
            </Tooltip>
            {show &&
                <SettingsDialog 
                    onClose={() => setShow(false)}
                    setParams={props.setParams}
                    palettes={props.config.palettes}
                    quiltParams={props.params} />
            }
        </>
    )
}